export function initPendo() {
    pendo.initialize({
        visitor: {
            id: ''
        }
    });
}